import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const branches = ["All Branches", "Downtown Gym", "Westside Fitness", "North Park Club", "East End Studio"];
const paymentMethods = ["All Methods", "Credit Card", "Cash", "Bank Transfer", "UPI / Digital"];
const agingPeriods = ["All Periods", "0–30 Days", "31–60 Days", "61–90 Days", "90+ Days"];

export default function GlobalControls({ branch, setBranch, paymentMethod, setPaymentMethod, agingPeriod, setAgingPeriod, isRefreshing, onRefresh, lastUpdated }) {
  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl p-3 lg:p-4 shadow-sm">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 flex-wrap">
        <div className="flex items-center gap-2 flex-1 flex-wrap">
          {[
            { label: "Branch", value: branch, setter: setBranch, options: branches, icon: "Building2" },
            { label: "Payment", value: paymentMethod, setter: setPaymentMethod, options: paymentMethods, icon: "CreditCard" },
            { label: "Aging", value: agingPeriod, setter: setAgingPeriod, options: agingPeriods, icon: "Clock" },
          ]?.map((ctrl) => (
            <div key={ctrl?.label} className="relative flex-shrink-0">
              <div className="flex items-center gap-1.5 px-3 py-2 bg-[var(--color-muted)] rounded-lg border border-[var(--color-border)] hover:border-[var(--color-primary)]/50 transition-colors">
                <Icon name={ctrl?.icon} size={14} color="var(--color-muted-foreground)" />
                <select
                  value={ctrl?.value}
                  onChange={(e) => ctrl?.setter(e?.target?.value)}
                  className="bg-transparent text-sm font-[var(--font-caption)] text-[var(--color-foreground)] outline-none cursor-pointer pr-4 appearance-none"
                  aria-label={`Filter by ${ctrl?.label}`}
                >
                  {ctrl?.options?.map((o) => <option key={o} value={o}>{o}</option>)}
                </select>
                <Icon name="ChevronDown" size={12} color="var(--color-muted-foreground)" className="pointer-events-none" />
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <div className="flex items-center gap-1.5 text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">
            <span className={`w-2 h-2 rounded-full ${isRefreshing ? "bg-amber-400 animate-pulse" : "bg-emerald-500"}`} />
            <span className="hidden sm:inline">{isRefreshing ? "Syncing..." : `Updated ${lastUpdated}`}</span>
          </div>
          <Button variant="outline" size="sm" iconName="RefreshCw" iconPosition="left" onClick={onRefresh} disabled={isRefreshing}>
            {isRefreshing ? "Refreshing" : "Refresh"}
          </Button>
        </div>
      </div>
    </div>
  );
}